import FormBuildEngine from './form-build-engine'

function mapAdapter(adapter) {
  const prefix = 'lc'
  // 从widget中取响应方法开头的方法
  if (!adapter) {
    throw new Error('适配器匹配对象必须注入')
  } else if (Array.isArray(adapter) || adapter.constructor === Object) {
    // 适配生命周期数据转换方法
    const map = FormBuildEngine.normalizeMap(adapter)

    const res = {}

    map.forEach(({ key, val }) => {
      res[key] = function mappedAdapter(...args) {
        const formArgs = [this.widget, this.formData, this.globalData, this.formConfigList]

        if (typeof val === 'function') {
          return val.apply(this, formArgs.concat(args))
        } else {
          if (!this.widget.componentType) {
            return
          }
          const config = this.$formBuildEngine.getComponentConfigWithType(this.widget.componentType)
          const methods = config.componentConfig.methods
          if (methods && methods[`${prefix}${this.$lodash.upperFirst(key)}`]) {
            if (typeof methods[`${prefix}${this.$lodash.upperFirst(key)}`] === 'function') {
              return methods[`${prefix}${this.$lodash.upperFirst(key)}`].apply(
                this,
                formArgs.concat(args)
              )
            } else {
              const lcMethods = methods[`${prefix}${this.$lodash.upperFirst(key)}`]
              if (typeof lcMethods[this.renderSence] === 'function') {
                return lcMethods[this.renderSence].apply(this, formArgs.concat(args))
              } else {
                console.warn(
                  `找不到当前renderSence:${
                    this.renderSence
                  }对应的方法${prefix}${this.$lodash.upperFirst(key)}`
                )
              }
            }
          } else {
            console.warn(`${key} 必须以${prefix}开头，并小写驼峰，不采用此方式，不能正常使用`)
          }
        }
      }
    })
    return res
  } else {
    throw new Error('适配器匹配对象必须注入对象和数据')
  }
}

function mapEvent(event) {
  const prefix = 'event'
  // 从widget中取响应方法开头的方法
  if (!event) {
    throw new Error('事件匹配对象必须注入')
  } else if (Array.isArray(event) || event.constructor === Object) {
    // 适配生命周期数据转换方法
    const map = FormBuildEngine.normalizeMap(event)

    const res = {}

    map.forEach(({ key, val }) => {
      res[key] = function mappedEvent(...args) {
        const formArgs = [this.widget, this.formData, this.globalData, this.formConfigList]

        if (typeof val === 'function') {
          return val.apply(this, formArgs.concat(args))
        } else {
          if (!this.widget.componentType) {
            return
          }
          const config = this.$formBuildEngine.getComponentConfigWithType(this.widget.componentType)
          const methods = config.componentConfig.methods
          if (methods && methods[`${prefix}${this.$lodash.upperFirst(key)}`]) {
            if (typeof methods[`${prefix}${this.$lodash.upperFirst(key)}`] === 'function') {
              return methods[`${prefix}${this.$lodash.upperFirst(key)}`].apply(
                this,
                formArgs.concat(args)
              )
            } else {
              const lcMethods = methods[`${prefix}${this.$lodash.upperFirst(key)}`]
              if (typeof lcMethods[this.renderSence] === 'function') {
                return lcMethods[this.renderSence].apply(this, formArgs.concat(args))
              } else {
                console.warn(
                  `找不到当前renderSence:${
                    this.renderSence
                  }对应的方法${prefix}${this.$lodash.upperFirst(key)}`
                )
              }
            }
          } else {
            console.warn(`${key} 必须以${prefix}开头，并小写驼峰，不采用此方式，不能正常使用`)
          }
        }
      }
    })
    return res
  } else {
    throw new Error('事件匹配对象必须注入对象和数据')
  }
}

export { mapAdapter, mapEvent }
